import React from "react";

export default function Footer() {
  return (
    <>
      <style>{`
        .footer {
          position: relative;
          width: 100%;
          overflow: hidden;
          border-top: 3px solid #ffdf00;
          background: rgba(15, 16, 20, 0.96);
          color: #f1f1f1;
          font-family: Arial, sans-serif;
        }

        .footer-inner {
          position: relative;
          z-index: 1;
          width: min(calc(100% - 64px), 1200px);
          margin: 0 auto;
        }

        .footer-main {
          position: relative;
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1.08fr);
          gap: clamp(24px, 4vw, 46px);
          padding: clamp(20px, 3vw, 30px) 24px 27px;
        }

        .footer-main > div {
          min-width: 0;
        }

        .footer-main-wave {
          position: absolute;
          right: 0;
          bottom: -2px;
          width: 42%;
          height: 48px;
          pointer-events: none;
        }

        .footer-main::after {
          content: "";
          position: absolute;
          top: 20px;
          bottom: 18px;
          left: calc(48.5% + 1px);
          width: 1px;
          background: rgba(210, 210, 210, 0.55);
        }

        .footer-branch,
        .footer-visit {
          margin: 0 0 10px;
          color: #ffdf00;
          font-size: 19px;
          font-weight: 700;
        }

        .footer-title {
          margin: 0;
          color: #f4f4f4;
          font-size: clamp(21px, 2.6vw, 27px);
          font-weight: 700;
          line-height: 1.25;
        }

        .footer-address {
          margin: 0;
          color: #ededed;
          font-size: 15px;
          line-height: 1.55;
          overflow-wrap: anywhere;
        }

        .footer-contact {
          display: flex;
          flex-wrap: wrap;
          gap: 7px 25px;
          margin-top: 10px;
        }

        .footer-contact a {
          color: #ededed;
          font-size: 15px;
          line-height: 1.4;
          text-decoration: none;
          overflow-wrap: anywhere;
        }

        .footer-contact a:hover,
        .footer-nav a:hover,
        .footer-legal a:hover {
          color: #ffdf00;
        }

        .footer-nav {
          position: relative;
          display: flex;
          flex-wrap: wrap;
          gap: 14px clamp(18px, 3vw, 30px);
          padding: 19px 30px 18px;
        }

        .footer-nav::before,
        .footer-nav::after {
          content: "";
          position: absolute;
          right: 0;
          left: 0;
          height: 2px;
          background: linear-gradient(
            to right,
            transparent,
            #e6ca00 12%,
            #e6ca00 88%,
            transparent
          );
          pointer-events: none;
        }

        .footer-nav::before {
          top: 0;
        }

        .footer-nav::after {
          bottom: 0;
        }

        .footer-nav a {
          color: #f1f1f1;
          font-size: 16px;
          font-weight: 600;
          text-decoration: none;
          overflow-wrap: anywhere;
        }

        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 12px 24px;
          min-height: 75px;
          padding: 12px 30px 25px;
          color: #e6e6e6;
          font-size: 15px;
        }

        .footer-copyright {
          margin: 0;
          line-height: 1.5;
        }

        .footer-legal {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 0;
        }

        .footer-legal a {
          padding: 0 18px;
          border-right: 1px solid #dedede;
          color: #e6e6e6;
          line-height: 1.6;
          text-decoration: none;
          white-space: nowrap;
        }

        .footer-legal a:first-child {
          padding-left: 0;
        }

        .footer-legal a:last-child {
          padding-right: 0;
          border-right: 0;
        }

        .footer-wave {
          position: absolute;
          z-index: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 42px;
          pointer-events: none;
        }

        @media (max-width: 900px) {
          .footer-inner {
            width: min(calc(100% - 40px), 720px);
          }

          .footer-main {
            gap: 28px;
            padding: 24px 14px 26px;
          }

          .footer-main::after {
            left: calc(48.5% + 1px);
          }

          .footer-nav {
            gap: 14px 24px;
            padding: 18px 14px;
          }

          .footer-nav a {
            font-size: 15px;
          }

          .footer-bottom {
            padding: 14px 14px 38px;
          }
        }

        @media (max-width: 640px) {
          .footer-inner {
            width: calc(100% - 32px);
          }

          .footer-main {
            grid-template-columns: minmax(0, 1fr);
            gap: 20px;
            padding: 22px 8px 26px;
          }

          .footer-main::after {
            display: none;
          }

          .footer-main-wave {
            width: 65%;
            height: 36px;
          }

          .footer-nav {
            gap: 14px 22px;
            padding: 17px 8px;
          }

          .footer-bottom {
            align-items: flex-start;
            flex-direction: column;
            gap: 12px;
            padding: 15px 8px 40px;
            font-size: 14px;
          }

          .footer-legal a {
            padding: 0 14px;
          }

          .footer-legal a:first-child {
            padding-left: 0;
          }

          .footer-wave {
            height: 34px;
          }
        }

        @media (max-width: 420px) {
          .footer-inner {
            width: calc(100% - 24px);
          }

          .footer-main {
            gap: 18px;
            padding: 20px 4px 24px;
          }

          .footer-branch,
          .footer-visit {
            font-size: 17px;
          }

          .footer-title {
            font-size: 21px;
          }

          .footer-address,
          .footer-contact a {
            font-size: 14px;
          }

          .footer-contact {
            flex-direction: column;
            align-items: flex-start;
            gap: 7px;
          }

          .footer-nav {
            gap: 12px 18px;
            padding-right: 4px;
            padding-left: 4px;
          }

          .footer-nav a {
            font-size: 14px;
          }

          .footer-bottom {
            padding-right: 4px;
            padding-left: 4px;
          }

          .footer-legal {
            gap: 5px 0;
          }

          .footer-legal a {
            padding: 0 9px;
            font-size: 13px;
          }

          .footer-legal a:first-child {
            padding-left: 0;
          }

          .footer-wave {
            height: 30px;
          }
        }
      `}</style>

      <footer className="footer" id="footer">
        <div className="footer-inner">
          <section className="footer-main">
            <div>
              <h2 className="footer-branch">Head Branch</h2>
              <h3 className="footer-title">
                Lakshya Computer Institute
                <br />
                &amp; Digital Library
              </h3>
            </div>

            <div>
              <h2 className="footer-visit">Visit us</h2>
              <p className="footer-address">
                Karwal Manjhgawa, Narre road near by RPD Academy, Tikari,
                District Gorakhpur, UP – 273411
                <br />
                ISO 9001:2015 Certified
              </p>
              <div className="footer-contact">
                <a href="tel:+919236895251">+91 9236895251</a>
                <a href="tel:+919793059441">+91 9793059441</a>
                {/* <a href="tel:+919793307525">+91 9793307525</a> */}
                <a href="mailto:rrrdigitalworld114@gmail.com">rrrdigitalworld114@gmail.com</a>
              </div>
            </div>
            <svg
              className="footer-main-wave"
              viewBox="0 0 400 48"
              preserveAspectRatio="none"
              aria-hidden="true"
            >
              <path
                fill="#a88d00"
                d="M0 47 C110 47 175 47 245 43 C310 39 345 13 400 0 L400 15 C345 27 310 45 245 47 C170 49 105 48 0 48 Z"
              />
              <path
                fill="#ffdf00"
                d="M0 47 C110 47 175 47 245 45 C310 43 350 22 400 7 L400 19 C348 32 310 48 245 49 C170 50 105 49 0 49 Z"
              />
            </svg>
          </section>

          <nav className="footer-nav" aria-label="Footer navigation">
            <a href="/">Home</a>
            <a href="/Courses">Courses</a>
            <a href="/Scholarship">Scholarship</a>
            <a href="/About">About</a>
            <a href="?Contact">Contact</a>
          </nav>

          <div className="footer-bottom">
            <p className="footer-copyright">
              © 2025 Lakshya Computer Institute. All Rights Reserved.
            </p>
            <nav className="footer-legal" aria-label="Legal links">
              <a href="/refund">Refund</a>
              <a href="/terms">Terms &amp; Conditions</a>
              <a href="/policy">Policy</a>
            </nav>
          </div>
        </div>

        <svg
          className="footer-wave"
          viewBox="0 0 1000 48"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            fill="#a88d00"
            d="M0 0 C70 40 122 42 220 39 C315 36 366 47 470 43 C585 39 650 43 740 45 C840 48 917 39 1000 5 L1000 48 L0 48 Z"
          />
          <path
            fill="#ffdf00"
            d="M0 12 C72 48 123 47 220 43 C316 39 365 48 470 46 C585 43 654 46 742 47 C840 49 922 44 1000 17 L1000 31 C920 50 843 50 742 49 C648 48 583 46 470 49 C366 51 316 44 220 48 C122 52 67 48 0 28 Z"
          />
        </svg>
      </footer>
    </>
  );
}
